import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-between gap-0 w-full !bg-surface-0 border-t py-1.5 pr-0 mr-3.5 border-surface-100 relative"
};
const _hoisted_2 = {
  class: "flex flex-col justify-center gap-0 w-full min-w-[15.625rem]"
};
const _hoisted_3 = {
  class: "text-surface-700 text-sm font-semibold ellipsis truncate max-w-[235px]"
};
const _hoisted_4 = {
  class: "text-surface-500 text-xs font-normal"
};
const _hoisted_5 = {
  class: "flex flex-col items-end w-full min-w-[5.313rem] font-normal text-surface-900 text-xs gap-3"
};
const _hoisted_6 = {
  class: ""
};
const _hoisted_7 = {
  class: ""
};
import { computed } from "vue";
import { $tf } from "@/plugins/i18n";
export default {
  __name: 'MainChildCell',
  props: {
    node: {
      type: Object,
      required: true
    },
    isLastChild: {
      type: Boolean,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const name = computed(() => {
      if (props.node.projectData?.name === "error.projectNotFound|Ismeretlen projekt") {
        return $tf(props.node.projectData?.name);
      } else {
        return props.node.projectData?.name;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(name.value), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(__props.node.projectData?.leadUserName), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref($tf)("timeManagementOverview.allocatedTime|Hozzárendelt idő")), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref($tf)("timeManagementOverview.loggedTime|Rögzített idő")), 1)]), _createElementVNode("div", {
        class: _normalizeClass(['absolute left-[-35px] top-[-1px] w-[1px] h-[calc(100%+1px)] bg-surface-200', {
          'h-[calc(80%)]': __props.isLastChild
        }])
      }, null, 2)]);
    };
  }
};